import {TwilioConnectFormFields} from "./TwilioConnectFormFields";

import {Button} from "@/components/ui/button";
import {Card, CardContent} from "@/components/ui/card";
import {useTwilioConnectForm} from "@/pages/assistant/quick-setup/hooks/forms/useTwilioConnectForm";

export const TwilioConnect = () => {
  const {form} = useTwilioConnectForm();

  return (
    <Card className="flex-1 cursor-pointer hover:shadow-md p-0">
      <CardContent>
        <div className="flex flex-col gap-4 py-4">
          <h4 className="text-sm text-secondary">
            Connect your Twilio account
          </h4>

          <TwilioConnectFormFields form={form} />

          <div className="flex items-center flex-1 mt-auto">
            <Button
              disabled={
                !form.formState.isValid ||
                form.formState.isValidating ||
                form.formState.isSubmitting
              }
              variant="outline-primary"
              className="ml-auto"
            >
              Connect
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
